import { render } from "./MenuBar.vue?vue&type=template&id=79731fb4&scoped=true&ts=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"

import "./MenuBar.vue?vue&type=style&index=0&id=79731fb4&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79731fb4"]])

export default __exports__